import { createStyles } from "antd-style";

export const useModalAddPaymentMethodStyles = createStyles(
  ({ token, css }: any) => ({
    root: css`
      .ant-modal-body {
        min-height: 500px;
      }
    `,
    form: css`
      display: flex;
      flex-direction: column;
      gap: 16px;
    `,
    savingOverlay: css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${token.ColorFigmaNeutralGrayscaleGray10};
      opacity: 0.95;
      z-index: 1000;
    `,
  }),
);
